import { IOption } from '#route/campaigns/components/refill-balance/types';

export enum EAutofillType {
    CREATE = 'create',
    EDIT = 'edit'
}

export enum EAutoFillFormType {
    BALANCE = 'balance',
    DEFAULT = 'default'
}

export interface IOptionSpecial extends IOption {
    readonly value: number
}

export type TEntitiesAutoRefillHistoryEntrySource = 'net' | 'balance' | 'all' | 'special';

export interface IRetryAnalytics {
    date: string,
    source: string,
    amount: number,
    last: 'True' | 'False'
}

export type TAnalytics = IRetryAnalytics & { source: TEntitiesAutoRefillHistoryEntrySource };
